import { useState } from 'react';
import Tooltip from '@/components/Tooltip';
import { useI18nText } from '@/lib/utils/i18nText';

interface SidebarFilterGroupProps {
  title: string;
  defaultOpen?: boolean;
  action?: React.ReactNode;
  children: React.ReactNode;
}

/**
 * Collapsible sidebar section with a bordered card layout (filter-group CSS).
 * Used in ChannelFilterSidebar (influencers) and rosters sidebar.
 */
export function SidebarFilterGroup({
  title,
  defaultOpen = false,
  action,
  children,
}: SidebarFilterGroupProps) {
  const [open, setOpen] = useState(defaultOpen);
  const { t } = useI18nText();

  return (
    <div className="filter-group">
      <div className="filter-group-header-row">
        <div className="filter-group-header">
          <Tooltip content={t('Click to expand or collapse', '클릭하면 펼치기/접기가 가능합니다')}>
            <button
              type="button"
              className="filter-group-caret-btn"
              aria-label={open ? t(`Collapse ${title}`, `${title} 접기`) : t(`Expand ${title}`, `${title} 펼치기`)}
              aria-expanded={open}
              onClick={() => setOpen((v) => !v)}
            >
              <i className={`fa fa-caret-${open ? 'down' : 'right'} filter-group-caret`} />
            </button>
          </Tooltip>
          <span className="filter-group-title">{title}</span>
        </div>
        {action && <div className="filter-group-action">{action}</div>}
      </div>
      {open && <div className="filter-group-body">{children}</div>}
    </div>
  );
}
